import axios from "axios";
import { withRouter } from "react-router-dom";
import React, { Component } from "react";
import { Button } from "@material-ui/core";
import { ref, uploadString, getDownloadURL } from "@firebase/storage";
import { storage } from "../../main-component/Firebase";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { Editor } from "@tinymce/tinymce-react";

class AppointmentCreateForm extends Component {
  state = {
    appointment_author: "",
    appointmentTitle: "",
    appointmentSubject: "",
    appointmenCoverImage: "",
    appointmenText: "",
    base64URL: "",
    error: {},
    appointmentsCount: 0,
    imageName: "",
    test: null,
  };

  editorRef = React.createRef(null);
  inputRef = React.createRef();
  getappointmentsCount = async () => {
    const result = await axios.get(
      `${process.env.REACT_APP_API_BASE}/appointment/get`,
      {
        headers: {
          Authorization: `Basic ${process.env.REACT_APP_TOKEN}`,
        },
      }
    );
    this.state.appointmentsCount = result.data[result.data.length - 1].id;
  };

  componentDidMount = async () => {
    this.getappointmentsCount();
    const error = this.state.error;
    error.appointment_author = "";

    // this.setState({
    //   ...this.state,
    //   appointment_author: this.props.name,
    //   error,
    // });
  };

  changeHandler = (e) => {
    const error = this.state.error;
    error[e.target.name] = "";

    this.setState({
      [e.target.name]: e.target.value,
      error,
    });
  };

  changeText = (value) => {
    const error = this.state.error;
    error.appointmenText = "";
    this.setState({
      appointmenText: value,
      error,
    });
  };

  getBase64 = (file) => {
    return new Promise((resolve) => {
      let baseURL = "";
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        baseURL = reader.result;
        resolve(baseURL);
      };
    });
  };

  uploadImage = (e) => {
    const error = this.state.error;
    error[e.target.name] = "";
    let { file } = this.state;
    file = e.target.files[0];
    this.setState({
      ...this.state,
      test: e.target.files[0],
    });
    this.getBase64(file)
      .then((result) => {
        file["base64"] = result;
        this.setState({
          base64URL: result,
          error,
        });
      })
      .catch((err) => {
        console.log(err);
      });
    this.changeHandler(e);
  };

  createAppointment = async () => {
    const imageRef = ref(
      storage,
      `appointment/${parseInt(this.state.appointmentsCount) + 1}`
    );
    await uploadString(imageRef, this.state.base64URL, "data_url").then(
      async (snapshot) => {
        this.state.appointmenCoverImage = await getDownloadURL(imageRef);
        this.postRequest();
      }
    );
  };

  postRequest = async () => {
    await axios
      .post(
        `${process.env.REACT_APP_API_BASE}/appointment/post?id=${
          parseInt(this.state.appointmentsCount) + 1
        }`,
        {
          id: parseInt(this.state.appointmentsCount) + 1,
          appointmentTitle: this.state.appointmentTitle,
          appointmentSubject: this.state.appointmentSubject,
          appointment_author: this.state.appointment_author,
          appointmentCreateDate: Date.now(),
          appointmentComments: 0,
          appointmenText: this.state.appointmenText,
          appointmenCoverImage: this.state.appointmenCoverImage,
        },
        {
          headers: {
            Authorization: `Basic ${process.env.REACT_APP_TOKEN}`,
          },
        }
      )
      .then((response) => {
        toast.success("Appointment created sucessfully!");
        this.resetStateValues();
        this.getappointmentsCount();
        // this.props.history.push(
        //   `/blog-single-fullwidth/${parseInt(this.state.appointmentsCount) + 1}`
        // );
      })
      .catch((error) => {
        console.log(error);
        toast.warning("Appointment NOT created");
        this.resetStateValues();
      });
  };

  resetStateValues = () => {
    this.setState({
      appointment_author: "",
      appointmentTitle: "",
      appointmentSubject: "",
      appointmenText: "",
      error: {},
      appointmenCoverImage: "",
      imageName: "",
    });
    this.inputRef.current.value = null;
  };

  subimtHandler = (e) => {
    e.preventDefault();
    const { error, appointment_author, appointmentTitle, appointmentSubject, imageName, appointmenText } = this.state;

    if (!appointment_author) {
      error.appointment_author = "Please enter your name";
    }
    if (!appointmentTitle) {
      error.appointmentTitle = "Please enter your appointmentTitle";
    }
    if (!appointmentSubject) {
      error.appointmentSubject = "Please enter your appointmentSubject";
    }
    if (!imageName) {
      error.imageName = "Please enter your cover image";
    }
    if (!appointmenText) {
      error.appointmenText = "Please enter your appointmenText";
    }
    if (error) {
      this.setState({
        error,
      });
      console.log(error);
    }
    if (
      error.appointment_author === "" &&
      error.appointmentTitle === "" &&
      error.appointmentSubject === "" &&
      error.appointmenText === "" &&
      error.imageName === ""
    ) {
      this.createAppointment();
    }
  };

  render() {
    const { appointment_author, appointmentTitle, appointmentSubject, appointmenText, error } = this.state;

    const { name } = this.props;
    return (
      <form onSubmit={this.subimtHandler} className="form">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-12">
            <div className="form-field">
              <input
                onChange={this.changeHandler}
                value={appointmentTitle}
                type="appointmenText"
                name="appointmentTitle"
                placeholder="Title"
              />
              <p>{error.appointmentTitle ? error.appointmentTitle : ""}</p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="form-field">
              <input
                value={appointment_author}
                onChange={this.changeHandler}
                type="appointmenText"
                name="appointment_author"
                placeholder="Author"
              />
              <p>{error.appointment_author ? error.appointment_author : ""}</p>
            </div>
          </div>

          <div className="col-lg-6 col-md-6 col-12">
            <div>
              <select
                name="appointmentSubject"
                className="form-control"
                value={appointmentSubject}
                onChange={this.changeHandler}
              >
                <option>Subject</option>
                <option>Wedding</option>
                <option>Wedding dress</option>
                <option>Wedding song</option>
                <option>Bride</option>
                <option>Bride shoes</option>
                <option>Groom</option>
                <option>Engagement</option>
                <option>Concept</option>
                <option>Flowers</option>
                <option>Photography</option>
                <option>Music</option>
                <option>Entertaiment</option>
                <option>DJ & Bands</option>
                <option>Cakes</option>
                <option>Bachelorette party</option>
                <option>Clothing</option>
                <option>Traditions</option>
                <option>Print</option>
              </select>
              <p>{error.appointmentSubject ? error.appointmentSubject : ""}</p>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-field">
              {/* <appointmenTextarea
                name="appointmenText"
                placeholder="Text"
                value={appointmenText}
                onChange={this.changeHandler}
              ></appointmenTextarea> */}
              <Editor
                apiKey={process.env.REACT_APP_TINYMCE_API_KEY}
                onInit={(evt, editor) => (this.editorRef.current = editor)}
                onEditorChange={(value) => this.changeText(value)}
                init={{
                  height: 500,
                  menubar: false,
                  plugins: [
                    "advlist",
                    "autolink",
                    "lists",
                    "link",
                    "image",
                    "charmap",
                    "preview",
                    "anchor",
                    "searchreplace",
                    "visualblocks",
                    "code",
                    "fullscreen",
                    "insertdatetime",
                    "media",
                    "table",
                    "code",
                    "help",
                    "wordcount",
                  ],
                  toolbar:
                    "undo redo | blocks | " +
                    "bold italic forecolor | alignleft aligncenter " +
                    "alignright alignjustify | bullist numlist outdent indent | " +
                    "removeformat | help",
                  content_style:
                    "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                }}
              />
              <p>{error.appointmenText ? error.appointmenText : ""}</p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6 col-12">
            <div className="form-field">
              <Button
                variant="contained"
                onClick={() => this.inputRef.current.click()}
              >
                Upload file
              </Button>
              <input
                onChange={this.uploadImage}
                type="file"
                ref={this.inputRef}
                name="imageName"
                placeholder="Cover image"
                accept="image/png, image/gif, image/jpeg"
                hidden
              />
              <p>{error.imageName ? error.imageName : ""}</p>
              {this.state.test && (
                <div
                  style={{
                    width: 300,
                    maxHeight: 300,
                    borderRadius: 8,
                    overflow: "hidden",
                  }}
                >
                  <img
                    style={{ width: "auto" }}
                    src={URL.createObjectURL(this.state.test)}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="col-lg-12">
            <div className="form-submit">
              <button type="submit" className="theme-btn-s4 mt-4">
                Submit
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}
export default withRouter(AppointmentCreateForm);
